module.exports = __webpack_public_path__ + "static/media/Payment-Illustration.a13d9625.svg";